import { render } from "./SetPriceModal.vue?vue&type=template&id=fed23178&scoped=true"
import script from "./SetPriceModal.vue?vue&type=script&lang=js"
export * from "./SetPriceModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositReview.scss?vue&type=style&index=0&id=fed23178&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed23178"]])

export default __exports__